//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IBFFClient {

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleMembersSelectionMode(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MembersSelectionModeRequest | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    multiToggleMembersSelectionMode(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MembersSelectionModeRequest[] | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param searchText (optional) Search by (rcu or name)
     * @param pageSize (optional) Page size
     * @param pageNumber (optional) Page number
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    getNetworkMemberDistribution(networkId: string, productType: ProductTypeRequest, marketId: number, searchText: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, x_Correlation_ID: string | undefined, body: string[] | undefined): Promise<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>>;

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    patchNetworkMemberDistribution(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MemberCreditDetailsRequest[] | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param contractId (optional) The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param searchText (optional) Search by (rcu or name)
     * @param pageSize (optional) Page size
     * @param pageNumber (optional) Page number
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    getMultiBeneficiariesMemberDistribution(contractId: number | undefined, productType: ProductTypeRequest, marketId: number, searchText: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, x_Correlation_ID: string | undefined, body: string[] | undefined): Promise<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>>;

    /**
     * @param contractId The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    patchMultiBeneficiariesMemberDistribution(contractId: number, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MemberCreditDetailsRequest[] | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNetworkAllRcuIds(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<string[]>>;

    /**
     * @param contractId The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMultiBeneficiariesAllRcuIds(contractId: number, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<string[]>>;

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    stashAllCredits(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param contractId The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    stashAllMultiBeneficiariesCredits(contractId: number, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMembersDistributionCsv(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<FileResponse>>;

    /**
     * @param contractId (optional) The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMultiBeneficiariesMembersDistributionCsv(contractId: number | undefined, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<FileResponse>>;

    /**
     * @param networkId (optional) The network id
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    buyMoreBoosts(networkId: string | undefined, x_Correlation_ID: string | undefined, body: BuyMoreBoostsDistributionControllerRequest | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    exportBuyMoreBoosts(x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * Get if should redirect to new hyperfaiseur
     * @param flagName (optional) 
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    featureflipping(flagName: string | undefined, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<boolean>>;

    /**
     * Check if the api is well deployed
     * @param x_Correlation_ID (optional) 
     * @return Api is well deployed
     */
    healthCheck(x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * Check if the api is well deployed
     * @param x_Correlation_ID (optional) 
     * @return Api is well deployed
     */
    dependencies(x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param request (optional) 
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getProductCreditListByPublication(request: string | undefined, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>;

    /**
     * @param request (optional) 
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getRepartitionContrats(request: string | undefined, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>;

    generateExportRepartitionContrats(request: string | undefined, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<FileResponse>>;

    generateExportRepartitionContratsAsJson(request: string | undefined, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    stashContractsVolumes(x_Correlation_ID: string | undefined, body: WebApiControllerRequest_1OfOfStashContractAllocationControllerRequestAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>;

    /**
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateVolumeContrats(x_Correlation_ID: string | undefined, body: WebApiControllerRequest_1OfOfUpdateContractsAllocationControllerRequestAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>;

    /**
     * Get navigation information for reis network
     * @param networkId (optional) The network id
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNavigationInformations(networkId: string | undefined, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>>;

    /**
     * Get navigation information for independant contracts
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNavigationInformationsForIndependant(x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>>;

    /**
     * Reset impersonated super admin
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    resetImpersonatedSuperAdmin(x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<void>>;

    /**
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    networks(x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<NetworksListResponse>>;

    /**
     * @param networkId (optional) The network id
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNetworkDistributionOverview(networkId: string | undefined, x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<GetDistributionOverviewResponse>>;

    /**
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMultiBeneficiariesDistributionOverview(x_Correlation_ID: string | undefined): Promise<BFFSwaggerResponse<GetDistributionOverviewResponse>>;
}

export class BFFClient implements IBFFClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    toggleMembersSelectionMode(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MembersSelectionModeRequest | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/autoselection/network/{networkId}/toggle?";
        if (networkId === undefined || networkId === null)
            throw new Error("The parameter 'networkId' must be defined.");
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleMembersSelectionMode(_response);
        });
    }

    protected processToggleMembersSelectionMode(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    multiToggleMembersSelectionMode(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MembersSelectionModeRequest[] | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/autoselection/network/{networkId}/multiToggle?";
        if (networkId === undefined || networkId === null)
            throw new Error("The parameter 'networkId' must be defined.");
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMultiToggleMembersSelectionMode(_response);
        });
    }

    protected processMultiToggleMembersSelectionMode(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param searchText (optional) Search by (rcu or name)
     * @param pageSize (optional) Page size
     * @param pageNumber (optional) Page number
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    getNetworkMemberDistribution(networkId: string, productType: ProductTypeRequest, marketId: number, searchText: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, x_Correlation_ID: string | undefined, body: string[] | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>> {
        let url_ = this.baseUrl + "/api/distribution/network/{networkId}?";
        if (networkId === undefined || networkId === null)
            throw new Error("The parameter 'networkId' must be defined.");
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNetworkMemberDistribution(_response);
        });
    }

    protected processGetNetworkMemberDistribution(response: Response): Promise<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMembersDistributionDistributionControllerResponse;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    patchNetworkMemberDistribution(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MemberCreditDetailsRequest[] | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/distribution/network/{networkId}?";
        if (networkId === undefined || networkId === null)
            throw new Error("The parameter 'networkId' must be defined.");
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchNetworkMemberDistribution(_response);
        });
    }

    protected processPatchNetworkMemberDistribution(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param contractId (optional) The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param searchText (optional) Search by (rcu or name)
     * @param pageSize (optional) Page size
     * @param pageNumber (optional) Page number
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    getMultiBeneficiariesMemberDistribution(contractId: number | undefined, productType: ProductTypeRequest, marketId: number, searchText: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, x_Correlation_ID: string | undefined, body: string[] | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>> {
        let url_ = this.baseUrl + "/api/distribution/contract/{contractId}?";
        if (contractId !== null && contractId !== undefined)
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        else
            url_ = url_.replace("/{contractId}", "");
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMultiBeneficiariesMemberDistribution(_response);
        });
    }

    protected processGetMultiBeneficiariesMemberDistribution(response: Response): Promise<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMembersDistributionDistributionControllerResponse;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<GetMembersDistributionDistributionControllerResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param contractId The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    patchMultiBeneficiariesMemberDistribution(contractId: number, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, body: MemberCreditDetailsRequest[] | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/distribution/contract/{contractId}?";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchMultiBeneficiariesMemberDistribution(_response);
        });
    }

    protected processPatchMultiBeneficiariesMemberDistribution(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNetworkAllRcuIds(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/distribution/network/{networkId}/rcuids?";
        if (networkId === undefined || networkId === null)
            throw new Error("The parameter 'networkId' must be defined.");
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNetworkAllRcuIds(_response);
        });
    }

    protected processGetNetworkAllRcuIds(response: Response): Promise<BFFSwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<string[]>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param contractId The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMultiBeneficiariesAllRcuIds(contractId: number, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/distribution/contract/{contractId}/rcuids?";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMultiBeneficiariesAllRcuIds(_response);
        });
    }

    protected processGetMultiBeneficiariesAllRcuIds(response: Response): Promise<BFFSwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<string[]>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    stashAllCredits(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/distribution/stash/network/{networkId}?";
        if (networkId === undefined || networkId === null)
            throw new Error("The parameter 'networkId' must be defined.");
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStashAllCredits(_response);
        });
    }

    protected processStashAllCredits(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param contractId The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    stashAllMultiBeneficiariesCredits(contractId: number, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/distribution/stash/contract/{contractId}?";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStashAllMultiBeneficiariesCredits(_response);
        });
    }

    protected processStashAllMultiBeneficiariesCredits(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId The network id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMembersDistributionCsv(networkId: string, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/distribution/network/{networkId}/csv?";
        if (networkId === undefined || networkId === null)
            throw new Error("The parameter 'networkId' must be defined.");
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMembersDistributionCsv(_response);
        });
    }

    protected processGetMembersDistributionCsv(response: Response): Promise<BFFSwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new BFFSwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<FileResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param contractId (optional) The contract id
     * @param productType Product type (default all) to filter by
     * @param marketId Market id to filter by
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMultiBeneficiariesMembersDistributionCsv(contractId: number | undefined, productType: ProductTypeRequest, marketId: number, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/distribution/contract/{contractId}/csv?";
        if (contractId !== null && contractId !== undefined)
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        else
            url_ = url_.replace("/{contractId}", "");
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined and cannot be null.");
        else
            url_ += "marketId=" + encodeURIComponent("" + marketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMultiBeneficiariesMembersDistributionCsv(_response);
        });
    }

    protected processGetMultiBeneficiariesMembersDistributionCsv(response: Response): Promise<BFFSwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new BFFSwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<FileResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId (optional) The network id
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    buyMoreBoosts(networkId: string | undefined, x_Correlation_ID: string | undefined, body: BuyMoreBoostsDistributionControllerRequest | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/distribution/buymore?";
        if (networkId === null)
            throw new Error("The parameter 'networkId' cannot be null.");
        else if (networkId !== undefined)
            url_ += "networkId=" + encodeURIComponent("" + networkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBuyMoreBoosts(_response);
        });
    }

    protected processBuyMoreBoosts(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    exportBuyMoreBoosts(x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/distribution/buymore";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportBuyMoreBoosts(_response);
        });
    }

    protected processExportBuyMoreBoosts(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get if should redirect to new hyperfaiseur
     * @param flagName (optional) 
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    featureflipping(flagName: string | undefined, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/featureflipping?";
        if (flagName === null)
            throw new Error("The parameter 'flagName' cannot be null.");
        else if (flagName !== undefined)
            url_ += "flagName=" + encodeURIComponent("" + flagName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFeatureflipping(_response);
        });
    }

    protected processFeatureflipping(response: Response): Promise<BFFSwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<boolean>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * Check if the api is well deployed
     * @param x_Correlation_ID (optional) 
     * @return Api is well deployed
     */
    healthCheck(x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * Check if the api is well deployed
     * @param x_Correlation_ID (optional) 
     * @return Api is well deployed
     */
    dependencies(x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/HealthCheck/dependencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDependencies(_response);
        });
    }

    protected processDependencies(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param request (optional) 
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getProductCreditListByPublication(request: string | undefined, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        let url_ = this.baseUrl + "/api/Hyperfaiseur/GetProductCreditListByPublication?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductCreditListByPublication(_response);
        });
    }

    protected processGetProductCreditListByPublication(response: Response): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param request (optional) 
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getRepartitionContrats(request: string | undefined, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        let url_ = this.baseUrl + "/api/Hyperfaiseur/GetRepartitionContrats?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRepartitionContrats(_response);
        });
    }

    protected processGetRepartitionContrats(response: Response): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    generateExportRepartitionContrats(request: string | undefined, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Hyperfaiseur/GenerateExportRepartitionContrats?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "text/csv"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateExportRepartitionContrats(_response);
        });
    }

    protected processGenerateExportRepartitionContrats(response: Response): Promise<BFFSwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new BFFSwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<FileResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    generateExportRepartitionContratsAsJson(request: string | undefined, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Hyperfaiseur/GenerateExportRepartitionContratsAsJson?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateExportRepartitionContratsAsJson(_response);
        });
    }

    protected processGenerateExportRepartitionContratsAsJson(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    stashContractsVolumes(x_Correlation_ID: string | undefined, body: WebApiControllerRequest_1OfOfStashContractAllocationControllerRequestAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        let url_ = this.baseUrl + "/api/Hyperfaiseur/StashContractsVolumes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStashContractsVolumes(_response);
        });
    }

    protected processStashContractsVolumes(response: Response): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param x_Correlation_ID (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateVolumeContrats(x_Correlation_ID: string | undefined, body: WebApiControllerRequest_1OfOfUpdateContractsAllocationControllerRequestAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        let url_ = this.baseUrl + "/api/Hyperfaiseur/UpdateVolumeContrats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateVolumeContrats(_response);
        });
    }

    protected processUpdateVolumeContrats(response: Response): Promise<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get navigation information for reis network
     * @param networkId (optional) The network id
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNavigationInformations(networkId: string | undefined, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>> {
        let url_ = this.baseUrl + "/api/navigation?";
        if (networkId === null)
            throw new Error("The parameter 'networkId' cannot be null.");
        else if (networkId !== undefined)
            url_ += "networkId=" + encodeURIComponent("" + networkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNavigationInformations(_response);
        });
    }

    protected processGetNavigationInformations(response: Response): Promise<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NavigationGetNavigationControllerResponse;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get navigation information for independant contracts
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNavigationInformationsForIndependant(x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>> {
        let url_ = this.baseUrl + "/api/navigation/independant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNavigationInformationsForIndependant(_response);
        });
    }

    protected processGetNavigationInformationsForIndependant(response: Response): Promise<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NavigationGetNavigationControllerResponse;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<NavigationGetNavigationControllerResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * Reset impersonated super admin
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    resetImpersonatedSuperAdmin(x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/navigation/resetImpersonatedSuperAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetImpersonatedSuperAdmin(_response);
        });
    }

    protected processResetImpersonatedSuperAdmin(response: Response): Promise<BFFSwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new BFFSwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<void>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    networks(x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<NetworksListResponse>> {
        let url_ = this.baseUrl + "/api/networks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNetworks(_response);
        });
    }

    protected processNetworks(response: Response): Promise<BFFSwaggerResponse<NetworksListResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NetworksListResponse;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<NetworksListResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param networkId (optional) The network id
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getNetworkDistributionOverview(networkId: string | undefined, x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<GetDistributionOverviewResponse>> {
        let url_ = this.baseUrl + "/api/overview/network/{networkId}";
        if (networkId !== null && networkId !== undefined)
        url_ = url_.replace("{networkId}", encodeURIComponent("" + networkId));
        else
            url_ = url_.replace("/{networkId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNetworkDistributionOverview(_response);
        });
    }

    protected processGetNetworkDistributionOverview(response: Response): Promise<BFFSwaggerResponse<GetDistributionOverviewResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDistributionOverviewResponse;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<GetDistributionOverviewResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param x_Correlation_ID (optional) 
     * @return OK
     */
    getMultiBeneficiariesDistributionOverview(x_Correlation_ID: string | undefined, signal?: AbortSignal): Promise<BFFSwaggerResponse<GetDistributionOverviewResponse>> {
        let url_ = this.baseUrl + "/api/overview/contract";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMultiBeneficiariesDistributionOverview(_response);
        });
    }

    protected processGetMultiBeneficiariesDistributionOverview(response: Response): Promise<BFFSwaggerResponse<GetDistributionOverviewResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDistributionOverviewResponse;
            return new BFFSwaggerResponse(status, _headers, result200);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BFFSwaggerResponse<GetDistributionOverviewResponse>>(new BFFSwaggerResponse(status, _headers, null as any));
    }
}

export enum ControllerWebApiResponseMessageCategory {
    _0 = "_0",
    _1 = "_1",
    _2 = "_2",
}

export enum ControllerWebApiResponseMessageScope {
    _0 = "_0",
    _1 = "_1",
}

export interface AllocationModificationControllerRequest {
    refProduit?: string | undefined;
    idTypePublication?: number | undefined;
    agences?: BeneficiaryContractAllocationControllerRequest[] | undefined;
}

export interface BeneficiaryContractAllocationControllerRequest {
    idTiers?: number | undefined;
    idContrat?: number | undefined;
    volumeAffecte?: number | undefined;
}

export interface BuyMoreBoostsDistributionControllerRequest {
    shouldSendEmail: boolean;
    productType: ProductTypeRequest;
    marketId: number;
    marketName: string | undefined;
    consumedBoosts: number | undefined;
    notConsumedBoosts: number | undefined;
    contractId?: number | undefined;
}

export interface ContractCriteriaControllerRequest {
    idContrat?: number | undefined;
    refProduit?: string | undefined;
    idTypePublication?: number | undefined;
}

export interface HVCriteresControllerRequest {
    idTypePublication?: number | undefined;
    idTypeTransactionGroup?: number | undefined;
    idTypeMandat?: number | undefined;
    idTypeBien?: number | undefined;
    idSousTypeBien?: number | undefined;
    dateDebut?: Date | undefined;
    dateFin?: Date | undefined;
    paging?: PagingControllerRequest;
    sortCriteria?: SortCriteriaControllerRequest;
    grain?: number | undefined;
    idReseau?: number | undefined;
}

export interface MemberCreditDetailsRequest {
    rcuId?: string | undefined;
    allocatedCredits?: number;
}

export interface MembersSelectionModeRequest {
    rcuIds?: string[] | undefined;
    selectionMode?: SelectionModeType;
}

export interface PagingControllerRequest {
    pageSize?: number | undefined;
    pageIndex?: number | undefined;
}

export interface SortCriteriaControllerRequest {
    parametre?: string | undefined;
    asc?: boolean | undefined;
}

export interface StashContractAllocationControllerRequest {
    partnerRelationshipId?: number;
    hyperFaiseurCriterias?: ContractCriteriaControllerRequest;
}

export interface UpdateContractsAllocationControllerRequest {
    criteres?: HVCriteresControllerRequest;
    volumes?: AllocationModificationControllerRequest;
    correlationId?: string | undefined;
    culture?: string | undefined;
}

export interface WebApiControllerRequest_1OfOfStashContractAllocationControllerRequestAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    request?: StashContractAllocationControllerRequest;
}

export interface WebApiControllerRequest_1OfOfUpdateContractsAllocationControllerRequestAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    request?: UpdateContractsAllocationControllerRequest;
}

export interface ControllerWebApiResponseMessage {
    Message?: string | undefined;
    Scope?: ControllerWebApiResponseMessageScope;
    Category?: ControllerWebApiResponseMessageCategory;
}

export interface ControllerWebApiValidationMessage {
    Field?: string | undefined;
    Message?: string | undefined;
}

export interface GetMembersDistributionDistributionControllerResponse {
    members?: MemberDistributionResponse[] | undefined;
    total?: number;
    pageSize?: number;
}

export interface GetProductCreditListByPublicationControllerData {
    ProductCredits?: PublicationProductListControllerResponse[] | undefined;
}

export interface GetRepartitionContractsControllerData {
    RepartitionContrats?: GetRepartitionContractsControllerResponse;
}

export interface GetRepartitionContractsControllerResponse {
    SommeVolumeSouscrit?: number | undefined;
    SommeVolumeAffecte?: number | undefined;
    SommeVolumeAffecteUtilise?: number | undefined;
    SommeVolumeAffecteNonUtilise?: number | undefined;
    SommeVolumeNonAffecte?: number | undefined;
    SommeVolumeNonAffecteUtilise?: number | undefined;
    SommeVolumeNonAffecteNonUtilise?: number | undefined;
    Contrats?: HyperFaiseurInfoContractControllerResponse[] | undefined;
    Agences?: HyperFaiseurAgencyContractsControllerResponse[] | undefined;
}

export interface HyperFaiseurAgencyContractsControllerResponse {
    IdTiers?: number | undefined;
    IdPartenaire?: string | undefined;
    RaisonSociale?: string | undefined;
    CodePostal?: string | undefined;
    Ville?: string | undefined;
    /** Date d'entrée. */
    DateEntree?: Date | undefined;
    SommeVolumeAffecte?: number | undefined;
    SommeVolumeAffecteUtilise?: number | undefined;
    SommeVolumeAffecteNonUtilise?: number | undefined;
    Contrats?: HyperFaiseurRepartitionAgenceContratControllerResponse[] | undefined;
}

export interface HyperFaiseurInfoContractControllerResponse {
    IdContrat?: number | undefined;
    NumContrat?: string | undefined;
    DateDebut?: Date | undefined;
    DateFin?: Date | undefined;
    VolumeSouscrit?: number | undefined;
    VolumeAffecte?: number | undefined;
    VolumeAffecteUtilise?: number | undefined;
    VolumeAffecteNonUtilise?: number | undefined;
    VolumeNonAffecte?: number | undefined;
    VolumeNonAffecteUtilise?: number | undefined;
    VolumeNonAffecteNonUtilise?: number | undefined;
}

export interface HyperFaiseurRepartitionAgenceContratControllerResponse {
    IdContrat?: number | undefined;
    EstDestinataireContrat?: boolean | undefined;
    VolumeAffecte?: number | undefined;
    VolumeAffecteUtilise?: number | undefined;
    VolumeAffecteNonUtilise?: number | undefined;
}

export interface HyperFaiseurRepartitionContratsControllerResponse {
    SommeVolumeSouscrit?: number | undefined;
    SommeVolumeAffecte?: number | undefined;
    SommeVolumeAffecteUtilise?: number | undefined;
    SommeVolumeAffecteNonUtilise?: number | undefined;
    SommeVolumeNonAffecte?: number | undefined;
    SommeVolumeNonAffecteUtilise?: number | undefined;
    SommeVolumeNonAffecteNonUtilise?: number | undefined;
    Contrats?: HyperFaiseurInfoContractControllerResponse[] | undefined;
    Agences?: HyperFaiseurAgencyContractsControllerResponse[] | undefined;
}

export interface HyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    CorrelationId?: string | undefined;
    ErrorCode?: number | undefined;
    Messages?: ControllerWebApiResponseMessage[] | undefined;
    RequestCulture?: string | undefined;
    ResponseCulture?: string | undefined;
    Timestamp?: Date | undefined;
    Validation?: ControllerWebApiValidationMessage[] | undefined;
    Data?: GetProductCreditListByPublicationControllerData;
}

export interface HyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    CorrelationId?: string | undefined;
    ErrorCode?: number | undefined;
    Messages?: ControllerWebApiResponseMessage[] | undefined;
    RequestCulture?: string | undefined;
    ResponseCulture?: string | undefined;
    Timestamp?: Date | undefined;
    Validation?: ControllerWebApiValidationMessage[] | undefined;
    Data?: GetRepartitionContractsControllerData;
}

export interface HyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    CorrelationId?: string | undefined;
    ErrorCode?: number | undefined;
    Messages?: ControllerWebApiResponseMessage[] | undefined;
    RequestCulture?: string | undefined;
    ResponseCulture?: string | undefined;
    Timestamp?: Date | undefined;
    Validation?: ControllerWebApiValidationMessage[] | undefined;
    Data?: StashVolumeContractControllerData;
}

export interface HyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    CorrelationId?: string | undefined;
    ErrorCode?: number | undefined;
    Messages?: ControllerWebApiResponseMessage[] | undefined;
    RequestCulture?: string | undefined;
    ResponseCulture?: string | undefined;
    Timestamp?: Date | undefined;
    Validation?: ControllerWebApiValidationMessage[] | undefined;
    Data?: UpdateVolumeContratsControllerData;
}

export interface MemberDistributionResponse {
    externalId?: string | undefined;
    rcuID?: string | undefined;
    name?: string | undefined;
    commercialName?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    addDate?: Date | undefined;
    isEnabled?: boolean;
    consumedBoosts?: number | undefined;
    allocatedBoosts?: number | undefined;
    selectionModeType?: SelectionModeType;
}

export interface NavigationApplicationURLAppControllerResponse {
    code?: string | undefined;
    url?: string | undefined;
    internalUrl?: string | undefined;
}

export interface NavigationApplicationURLControllerResponse {
    code?: string | undefined;
    app?: NavigationApplicationURLAppControllerResponse;
}

export interface NavigationCurrentuserControllerResponse {
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    login?: string | undefined;
}

export interface NavigationGetNavigationControllerResponse {
    isSuperAdminActive?: boolean;
    impersonatedUser?: boolean;
    isHyperviseurActive?: boolean;
    intermediaryName?: string | undefined;
    currentUser?: NavigationCurrentuserControllerResponse;
    applicationsURL?: NavigationApplicationURLControllerResponse[] | undefined;
    sideApplicationsURL?: NavigationApplicationURLControllerResponse[] | undefined;
    networks?: NavigationNetworkControllerResponse[] | undefined;
}

export interface NavigationNetworkControllerResponse {
    name?: string | undefined;
    id?: string | undefined;
}

export interface ProductDescriptionControllerResponse {
    Libelle?: string | undefined;
    Description?: string | undefined;
    Reference?: string | undefined;
}

export interface PublicationProductCreditControllerResponse {
    IdPublicationType?: number | undefined;
    PublicationTypeLabel?: string | undefined;
    NbAssigned?: number | undefined;
    NbAssignedNotUsed?: number | undefined;
    NbAssignedUsed?: number | undefined;
    NbNotAssigned?: number | undefined;
    TotalSubscribed?: number | undefined;
}

export interface PublicationProductListControllerResponse {
    ProductDescription?: ProductDescriptionControllerResponse;
    ProductCredits?: PublicationProductCreditControllerResponse[] | undefined;
}

/** This is to be ISO with the legacy behaviour. Sorry */
export interface ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    d?: HyperfaiseurWebApiControllerReponse_1OfOfGetProductCreditListByPublicationControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
}

/** This is to be ISO with the legacy behaviour. Sorry */
export interface ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    d?: HyperfaiseurWebApiControllerReponse_1OfOfGetRepartitionContractsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
}

/** This is to be ISO with the legacy behaviour. Sorry */
export interface ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    d?: HyperfaiseurWebApiControllerReponse_1OfOfStashVolumeContractControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
}

/** This is to be ISO with the legacy behaviour. Sorry */
export interface ResponseWrapper_1OfOfHyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_nullAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null {
    d?: HyperfaiseurWebApiControllerReponse_1OfOfUpdateVolumeContratsControllerDataAndBFFAnd_0AndCulture_neutralAndPublicKeyToken_null;
}

export interface StashVolumeContractControllerData {
    RepartitionContrats?: GetRepartitionContractsControllerResponse;
}

export interface UpdateVolumeContratsControllerData {
    RepartitionContrats?: HyperFaiseurRepartitionContratsControllerResponse;
}

export enum SelectionModeType {
    Manual = "Manual",
    Auto = "Auto",
}

export enum ProductTypeRequest {
    All = "All",
    BoostListe = "BoostListe",
    BoostExtend = "BoostExtend",
    AnnonceOr = "AnnonceOr",
    AnnonceArgent = "AnnonceArgent",
    BoostAlert = "BoostAlert",
}

export interface GetDistributionDetailsResponse {
    contractId?: number;
    total?: number;
    assigned?: number;
    consumed?: number;
    consumedNotAssigned?: number;
    readonly available?: number;
    readonly assignedNotUsed?: number;
    readonly notUsed?: number;
    readonly consumption?: number;
}

export interface GetDistributionOverviewMarketResponse {
    id?: number;
    label?: string | undefined;
    totalCredits?: number;
    products?: GetDistributionOverviewProductResponse[] | undefined;
}

export interface GetDistributionOverviewProductResponse {
    id?: number;
    label?: string | undefined;
    contracts?: GetDistributionDetailsResponse[] | undefined;
    totalAmountOfCredits?: number;
    totalAttributedOfCredits?: number;
    totalAmountOfUsedCredits?: number;
    totalAmountOfUsedCreditsUnassigned?: number;
    isEligibleAutoSelection?: boolean;
    readonly totalAvailableBoosts?: number;
    readonly totalAssignedNotUsedBoosts?: number;
    readonly totalNotUsedBoosts?: number;
    readonly consumption?: number;
}

export interface GetDistributionOverviewResponse {
    markets?: GetDistributionOverviewMarketResponse[] | undefined;
}

export interface NetworkData {
    id?: string | undefined;
    name?: string | undefined;
    intermediaryNumber?: number;
}

export interface NetworksListResponse {
    items?: NetworkData[] | undefined;
    total?: number;
}

export class BFFSwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}